export default "__VITE_ASSET__HJrGSBcC__"